<template>
  <div>
    <v-layout
      row
      justify-center
    >
      <v-dialog
        v-model="addEditRoleModal"
        persistent
        max-width="500px"
      >
        <v-card>
          <form @submit.prevent="submitForm()">
            <v-card-title class="pb-0">
              <v-flex
                xs11
                sm10
                md10
              ><span class="headline">
                  {{ isUpdate ? 'Update Role' : 'Add New Role' }}
                </span></v-flex>
              <v-flex
                xs1
                sm2
                md2
              >
                <v-btn
                  flat
                  @click="closeDialog()"
                  class="close"
                >
                  &nbsp;X</v-btn>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-alert
                type="success"
                :value="isDone"
              >
                {{ isUpdate ? 'Updated successfully' : 'Added successfully' }}
              </v-alert>

              <v-alert
                type="error"
                :value="errorAlert"
              >
                There is an error
              </v-alert>
              <v-layout wrap>

                <v-flex xs12>
                  <v-text-field
                    label="Name *"
                    v-model="formData.status"
                    :error-messages="errors.collect('Name')"
                    v-validate="'required'"
                    data-vv-name="Name"
                  />
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="height:auto"
                @click="closeDialog()"
                outline
                color="normal"
              >Cancel</v-btn>
              <v-btn
                type="submit"
                :loading="loading"
                style="height:auto; margin-right: 2%"
                outline
                color="success"
              >
                {{ isUpdate ? 'Save' : 'Add' }}
              </v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import Axios from 'axios'

export default {
  props: ['addEditRoleModal', 'formData', 'isUpdate'],

  data() {
    return {
      loading: false,
      isDone: false,
      errorAlert: false
    }
  },

  methods: {
    closeDialog() {
      this.$validator.reset()
      this.$emit('close')
    },

    submitForm() {
      let token = localStorage.getItem('access_token')

      this.$validator.validateAll().then((res) => {
        if (res) {
          if (this.isUpdate) {
            Axios.put(`api/role/${this.formData.role_id}`, this.formData, {
              headers: { Authorization: 'Bearer ' + token }
            })
              .then(() => {
                this.errorAlert = false
                this.isDone = true
                setTimeout(() => {
                  this.isDone = false
                  this.$emit('resetTable')
                  this.closeDialog()
                }, 2000)
              })
              .catch(() => {
                this.isDone = false
                this.errorAlert = true
                setTimeout(() => {
                  this.errorAlert = false
                }, 1500)
              })
          } else {
            Axios.post('api/role', this.formData, {
              headers: { Authorization: 'Bearer ' + token }
            })
              .then(() => {
                this.errorAlert = false
                this.isDone = true
                setTimeout(() => {
                  this.isDone = false
                  this.$emit('resetTable')
                  this.closeDialog()
                }, 2000)
              })
              .catch(() => {
                this.isDone = false
                this.errorAlert = true
                setTimeout(() => {
                  this.errorAlert = false
                }, 1500)
              })
          }
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden !important;
  overflow-y: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/roles/addEditRole.vue